// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1EC_-","dragIcon":"Choice_dragIcon__15Laq","left":"Choice_left__mHNal","input":"Choice_input__2nuGY"};